import { WidgetText, WidgetTextProps } from "./WidgetText";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetMeasureTextComponent } from "../Components/WidgetMeasureTextComponent";
import { PopupMeasureTextComponent } from "../Popups/PopupMeasureTextComponent";

export class WidgetMeasureTextProps extends WidgetTextProps {
    measureId: number;
}

export class WidgetMeasureText extends WidgetText {

    getType(): WidgetTypes {
        return WidgetTypes.MeasureText;
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetMeasureTextComponent({
            widget: this,
            measureId: parseInt((document.getElementById("ParentId") as HTMLInputElement).value)
        });
        return this.component.render();
    }

    showPopup(): void {
        let popup = new PopupMeasureTextComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}